/* Live-animal request form. Loaded by sections/live-animal-form.liquid.
   The one NZW page offers two health grades, so its CTAs land here with ?model=spf or
   ?model=conventional and this preselects the matching "Research model" option (matched on the
   option text, so the locale wording can change). Nothing else on the form is scripted. */
(function () {
  'use strict';

  var want = (new URLSearchParams(window.location.search).get('model') || '').toLowerCase();
  if (!want) return;
  var select = document.getElementById('LaForm-model');
  if (!select) return;
  for (var i = 0; i < select.options.length; i++) {
    var text = select.options[i].text.toLowerCase();
    var isSpf = text.indexOf('spf') !== -1 || text.indexOf('pasteurella') !== -1;
    if ((want === 'spf' && isSpf) || (want === 'conventional' && !isSpf && text.indexOf('conventional') !== -1)) {
      select.selectedIndex = i;
      break;
    }
  }
})();
